import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/account`;

export const accountService = {
    createAccount: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-account`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateAccount: async function (key:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-account`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteAccount: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-account`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    accountList: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list-account`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    lookupAccounts: async function (loadOptions:any)  {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/lookup-accounts`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupAllAccounts: async function (loadOptions:any)  {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/lookup-all-accounts`,{
            params
        }).then((response) => {
            return response.data;
        });;
    },
    getAccount: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-account`, {
            params: { id: id }
        })
        .then((response) => {
            return response.data;
        });
    }
}